module.exports = __webpack_public_path__ + "NU-SLS.jpg?8e07a7dea21c87e562b364b50edf7392";